import React, { useState, useEffect } from 'react';
import { Formik, Form, Field } from 'formik';
import { useHistory } from 'react-router';
import * as Yup from 'yup';
import Box from '@material-ui/core/Box';
import { LOGOUT } from 'ConstComponents';
import { Select as SENDER_SELECT } from 'Components/Api/MasterMoneyDMTAPI';
import { SelectBank as BANK_SELECT } from 'Components/Api/MasterMoneyDMTAPI';
import { AddBeneficiary as BENE_ADD } from 'Components/Api/MasterMoneyDMTAPI';
import ReactTable from 'Components/ReactTable/ReactTable';
import { MaterialTextField } from 'Components/Inputes/FormikMaterialInput';
import { MaterialNumberField } from 'Components/Inputes/FormikMaterialNumberInput';
import { MoneyTransfer as DMT_TRANSFER } from 'Components/Api/MasterMoneyDMTAPI';
import { Container, Grid, Paper, Button, Hidden } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';

import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import {
    MESSAGE_CLOSE_AFTER,
    PLEASE_PROVIDE_VALID,
    PLEASE_SELECT_VALID
} from 'Components/Helper/Messages';
import { ViewBeneficiary as BENE_SELECT } from 'Components/Api/MasterMoneyDMTAPI';
import { AutoCompleteTextView } from 'Components/Inputes/AutoCompleteTextView';
import { useLocation } from 'react-router-dom';
import HOCLoader from 'Components/Loader/HOCLoader';
import { CONSUMER_NUMBER_FONT_SIZE } from 'Config';
const CustomContainer = HOCLoader(Container);

export const BeneficiaryAdd = () => {
    const classes = commonStyle();
    const history = useHistory();
    const location = useLocation();
    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [bankList, setBankList] = useState([]);
    const [severity, setSeverity] = useState('success');
    const [mainColumns, setMainColumns] = useState([]);
    const [list, setList] = useState([]);
    const Mobile = location?.state?.Mobile;
    const SenderID = location?.state?.SenderID;
    const SenderName = location?.state?.SenderName;
    const [isAddOnly, setIsAddOnly] = useState(false);
    const [isReadOnly, setReadOnly] = useState(false);
    const [bankDefault, setBankDefault] = useState({
        BankID: 0,
        Name: 'Select Bank',
        DefaultIFSC: ''
    });
    const [consumerNumberFontSize, setConsumerNumberFontSize] = useState('');
    async function fetchConsumerNumberFontSize() {
        setConsumerNumberFontSize(await CONSUMER_NUMBER_FONT_SIZE());
    }
    const [formObject, setFormObject] = useState({
        Mobile: Mobile,
        Name: '',
        Bank: bankDefault,
        AccountNo: '',
        ConfirmAccountNo: '',
        IFSC: '',
        SenderID: SenderID,
        isAddOnly: false,
        IsNameVerified: false
    });

    useEffect(() => {
        selectBank();
        selectBene();
        createColumns();
    }, []);

    const selectBene = async () => {
        setLoading(true);
        setIsError(false);

        if (Mobile === undefined) return;

        if (Mobile === '') return;

        var beneReqObj = JSON.stringify({ Mobile: Mobile });

        var response = await BENE_SELECT(beneReqObj);

        setLoading(false);
        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setSeverity('error');
            setIsError(true);
            setResponseMessage(response.data);
            return;
        }

        var data = JSON.parse(response.data);

        setList(data);
    };

    const selectBank = async () => {
        setLoading(true);
        const response = await BANK_SELECT();

        if (!response.isAuthorized) {
            LOGOUT();
        }
        if (!response.status) {
            setResponseMessage(response.data);
            setIsError(true);
        }

        var data = JSON.parse(response.data);

        let objWithSelectAll = [bankDefault, ...data];

        setBankList(objWithSelectAll);
    };
    const createColumns = () => {
        var columns = [];

        columns.push({
            label: '#',
            name: 'BeneficiaryID',
            srno: true
        });
        columns.push({
            label: 'Name',
            name: 'Name'
        });
        columns.push({
            label: 'Bank',
            name: 'BankName'
        });
        columns.push({
            label: 'AccountNo',
            name: 'AccountNo'
        });

        columns.push({
            label: 'IFSC',
            name: 'IFSC'
        });

        setMainColumns(columns);
    };
    const submithandle = async (
        values,
        { setSubmitting, resetForm, setFieldValue }
    ) => {
        if (loading) {
            setLoading(false);
            return;
        }

        if (values.isAddOnly === true) {
            setIsAddOnly(true);
            core_bene_add(values, values.Name);
            return;
        }

        let jsonObj = {
            Mobile: values.Mobile,
            Name: values.Name,
            BankName: values.Bank.Name,
            SenderName: SenderName,
            AccountNo: values.AccountNo,
            IFSC: values.IFSC,
            BeneficiaryID: values.Mobile,
            SenderID: values.Mobile,
            Amount: 1,
            PaymentType: 'IMPS',
            RechargePin: '',
            Through: 'WEB',
            IsVerify: true
        };

        setIsError(false);
        setLoading(true);

        var apirequest = JSON.stringify(jsonObj);

        var response = await DMT_TRANSFER(apirequest);
        setLoading(false);

        if (!response.isAuthorized) LOGOUT();

        setIsError(true);

        if (!response.status) {
            var dataError = JSON.parse(response.data);
            setSeverity('error');
            setResponseMessage(dataError.Message);

            setIsError(true);
            return;
        }

        setSeverity('success');
        var data = JSON.parse(response.data);

        setResponseMessage(data.Message);
        setIsError(true);

        if (data.Status === 'SUCCESS') {
            setReadOnly(true);
            setFieldValue('IsNameVerified', true);
        }

        setFieldValue('Name', data.BeneficiaryName);
    };

    const core_bene_add = async (values, beneName) => {
        setResponseMessage('');
        var request = {
            Name: values.Name,
            BankName: values.Bank.BankID,
            AccountNo: values.AccountNo,
            IFSC: values.IFSC,
            SenderID: values.SenderID,
            SenderMobile: values.Mobile,
            IsNameVerified: values.IsNameVerified
        };

        var requestObj = JSON.stringify(request);

        setLoading(true);
        setIsError(false);

        var response = await BENE_ADD(requestObj);

        if (!response.isAuthorized) {
            LOGOUT();
        }
        if (!response.status) {
            setSeverity('error');
            setResponseMessage(response.data);
            setLoading(false);
            return;
        }

        setIsError(true);
        setResponseMessage(response.data);
        setSeverity('success');
        let params = {
            Mobile: values.Mobile
        };

        history.push('/MMoney_SenderSearch', params);
    };

    const FormValidationSchema = Yup.object({
        Bank: Yup.object()
            .nullable(PLEASE_SELECT_VALID + 'bank')
            .required(PLEASE_SELECT_VALID + 'bank')
            .shape({
                Name: Yup.string()
                    .nullable(PLEASE_SELECT_VALID + 'bank')
                    .required(PLEASE_SELECT_VALID + 'bank'),
                BankID: Yup.string()
                    .notOneOf(['0'], PLEASE_SELECT_VALID + 'bank')
                    .required(PLEASE_SELECT_VALID + 'bank'),
                DefaultIFSC: Yup.string()
                    .nullable(PLEASE_SELECT_VALID + 'bank')
                    .required(PLEASE_SELECT_VALID + 'bank')
            }),

        Mobile: Yup.string()
            .required(PLEASE_PROVIDE_VALID + 'mobile')
            .length(10, PLEASE_PROVIDE_VALID + 'mobile'),
        isAddOnly: Yup.boolean(),

        Name: Yup.string().when(['isAddOnly'], {
            is: (isAddOnly) => isAddOnly,
            then: Yup.string().required(PLEASE_PROVIDE_VALID + 'name')
        }),
        AccountNo: Yup.string()
            .required(PLEASE_PROVIDE_VALID + 'account no')
            .min(7, PLEASE_PROVIDE_VALID + 'account no')
            .max(20, PLEASE_PROVIDE_VALID + 'account no'),

        ConfirmAccountNo: Yup.string()
            .required(PLEASE_PROVIDE_VALID + 'confirm account no')
            .min(7, PLEASE_PROVIDE_VALID + 'account no')
            .max(20, PLEASE_PROVIDE_VALID + 'account no')
            .oneOf([Yup.ref('AccountNo'), null], "AccountNo don't match"),

        IFSC: Yup.string()
            .required(PLEASE_PROVIDE_VALID + 'IFSC')
            .length(11, PLEASE_PROVIDE_VALID + 'IFSC')
    });

    return (
        <CustomContainer
            isLoading={loading}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                enableReinitialize={true}
                initialValues={formObject}
                validationSchema={FormValidationSchema}
                onSubmit={submithandle}
                resetForm={formObject}
            >
                {({ values, setFieldValue, handleSubmit }) => {
                    return (
                        <Grid
                            item
                            container
                            margin="normal"
                            xs={12}
                            md={12}
                            sm={12}
                            lg={12}
                            spacing={2}
                        >
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <Form>
                                    <h2 className={classes.PaperHead_h2}>
                                        Beneficiary Add
                                    </h2>
                                    <Grid item xs={12}>
                                        <Paper className={classes.PaperStyle}>
                                            <Grid container spacing={2}>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                >
                                                    <Field
                                                        component={
                                                            AutoCompleteTextView
                                                        }
                                                        defaultValue={
                                                            bankDefault
                                                        }
                                                        SubFieldName="Name"
                                                        FieldName="Bank"
                                                        name="Bank"
                                                        options={bankList}
                                                        getOptionLabel={(
                                                            option
                                                        ) => option.Name}
                                                        getOptionSelected={(
                                                            option,
                                                            value
                                                        ) =>
                                                            option.Name ===
                                                            value.Name
                                                        }
                                                        textFieldProps={{
                                                            label: 'Bank'
                                                        }}
                                                        onCustomCallback={(
                                                            name,
                                                            value
                                                        ) => {
                                                            setFieldValue(
                                                                'IFSC',
                                                                value.DefaultIFSC
                                                            );

                                                            setFieldValue(
                                                                'Bank.Name',
                                                                value.Name
                                                            );
                                                            setFieldValue(
                                                                'Bank.BankID',
                                                                value.BankID
                                                            );

                                                            setBankDefault({
                                                                DefaultIFSC:
                                                                    value.DefaultIFSC,
                                                                Name:
                                                                    value.Name,
                                                                BankID:
                                                                    value.BankID
                                                            });
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                >
                                                    <MaterialTextField
                                                        label="IFSC"
                                                        name="IFSC"
                                                        type="text"
                                                        length={11}
                                                        readOnly={isReadOnly}
                                                        placeholder="IFSC"
                                                    />
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                >
                                                    <MaterialTextField
                                                        font_size={
                                                            consumerNumberFontSize
                                                        }
                                                        label="Account No."
                                                        autoComplete="new-password"
                                                        name="AccountNo"
                                                        type="password"
                                                        length={21}
                                                        placeholder="Account No."
                                                    />
                                                </Grid>

                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={9}
                                                    lg={9}
                                                >
                                                    <MaterialTextField
                                                        font_size={
                                                            consumerNumberFontSize
                                                        }
                                                        label="Confirm Account No."
                                                        name="ConfirmAccountNo"
                                                        type="text"
                                                        length={21}
                                                        readOnly={isReadOnly}
                                                        placeholder="Confirm Account No."
                                                    />
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={3}
                                                    lg={3}
                                                >
                                                    <div
                                                        className={
                                                            classes.SubmitWrapper
                                                        }
                                                    >
                                                        <Button
                                                            type="submit"
                                                            title="Verify"
                                                            className={
                                                                classes.CustomPrimaryButtonStyle
                                                            }
                                                            onClick={(e) => {
                                                                setFieldValue(
                                                                    'isAddOnly',
                                                                    false
                                                                );
                                                                handleSubmit(e);
                                                            }}
                                                            disabled={loading}
                                                        >
                                                            Verify
                                                        </Button>
                                                        {loading && (
                                                            <CircularProgress
                                                                size={24}
                                                                className={
                                                                    classes.buttonProgress
                                                                }
                                                            />
                                                        )}
                                                    </div>
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                >
                                                    <MaterialTextField
                                                        label="Bene Name"
                                                        name="Name"
                                                        type="text"
                                                        readOnly={isReadOnly}
                                                        placeholder="Bene Name"
                                                    />
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                >
                                                    <MaterialTextField
                                                        label="Mobile"
                                                        name="Mobile"
                                                        type="text"
                                                        length={10}
                                                        readOnly={true}
                                                        placeholder="Mobile"
                                                    />
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                >
                                                    <Hidden xsUp>
                                                        <MaterialTextField
                                                            label="SenderID"
                                                            name="SenderID"
                                                            type="text"
                                                            readOnly={true}
                                                            placeholder="SenderID"
                                                        />
                                                    </Hidden>

                                                    <Hidden xsUp>
                                                        <MaterialTextField
                                                            label="IsNameVerified"
                                                            name="IsNameVerified"
                                                            type="text"
                                                            placeholder="IsNameVerified"
                                                        />
                                                    </Hidden>
                                                </Grid>
                                            </Grid>
                                        </Paper>
                                    </Grid>

                                    <Grid className={classes.footerGrid}>
                                        <Box className={classes.flexReverse}>
                                            <div
                                                className={
                                                    classes.SubmitWrapper
                                                }
                                            >
                                                <Button
                                                    type="submit"
                                                    title="Add"
                                                    className={
                                                        classes.CustomPrimaryButtonStyle
                                                    }
                                                    onClick={(e) => {
                                                        setFieldValue(
                                                            'isAddOnly',
                                                            true
                                                        );
                                                        handleSubmit(e);
                                                    }}
                                                    disabled={loading}
                                                >
                                                    Add
                                                </Button>
                                                {loading && (
                                                    <CircularProgress
                                                        size={24}
                                                        className={
                                                            classes.buttonProgress
                                                        }
                                                    />
                                                )}
                                            </div>
                                            <Button
                                                type="reset"
                                                title="Reset"
                                                className={
                                                    classes.CustomDangerButtonStyle
                                                }
                                            >
                                                Reset
                                            </Button>

                                            <Button
                                                type="reset"
                                                title="Cancel"
                                                className={
                                                    classes.CustomDangerButtonStyle
                                                }
                                                onClick={(e) => {
                                                    var param = {
                                                        Mobile: values.Mobile
                                                    };
                                                    history.push(
                                                        '/MMoney_SenderSearch',
                                                        param
                                                    );
                                                }}
                                            >
                                                Cancel
                                            </Button>
                                        </Box>
                                    </Grid>
                                </Form>
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                sm={12}
                                md={8}
                                lg={8}
                                className="lastrecharges"
                            >
                                <h2 className={classes.PaperHead_h2}>
                                    Beneficiary List
                                </h2>
                                <ReactTable data={list} columns={mainColumns} />
                            </Grid>
                        </Grid>
                    );
                }}
            </Formik>
        </CustomContainer>
    );
};
